export const calculatePercentage = (previousPrice, price) => {
  if (!previousPrice || !price) {
    return "";
  }
  const previous = typeof previousPrice === "string" ? Number(previousPrice) : previousPrice;
  const currently = typeof price === "string" ? Number(price) : price;

  const percentage = ((previous - currently) * 100) / previous;
  const roundedPercentage = Math.round(percentage);
  return roundedPercentage;
};
